import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import IntrovokeEmbed from 'common/compounds/VirtualEventRenderer/states/components/elements/Embed/IntrovokeEmbed';

import AdviseBanner from './components/AdviseBanner';

/**
 * Get the bootstrap data that PHP left for us
 */
const bootstrap = getBootstrap();
const splashStudioId = bootstrap.get('splashStudioId');
const shouldRenderTermsAndConditionsNotification = bootstrap.get('isTermsAndConditionsNotificationEnabled') || false;

function StudioHostPreviewer() {
    return (
        <>
            <AdviseBanner shouldRenderTermsAndConditionsNotification={shouldRenderTermsAndConditionsNotification} />
            <IntrovokeEmbed introvokeEventId={splashStudioId} shouldRefreshEmbeds={false} />
        </>
    );
}

export default StudioHostPreviewer;
